<template>
	<div class="aboutus">
		<h1>关于我们</h1>
		<!-- <h2>About&nbsp;&nbsp;Us</h2> -->
	<!-- 	<div class="aboutus-one" id="container">

		</div> -->
		<div id="container" class="aboutus-one"></div>
		<div class="aboutus-two">
			<p>公司宗旨</p>
			<ul>
				<li>以人为本&nbsp;&nbsp;&nbsp;&nbsp;诚信务实
				</li>
				<li>精益求精&nbsp;&nbsp;&nbsp;&nbsp;敬天爱人
				</li>
				<li>绿色环保&nbsp;&nbsp;&nbsp;&nbsp;服务未来
				</li>
			</ul>
		</div>
	</div>

</template>

<script>
	// 引入加载TXMap的方法
	import {
		TMap
	} from '@/utils/QQTmap.js'
	export default {
		data() {
			return {

			};
		},
		created: function() {

		},
		mounted: function() {
			let that = this;
			this.$nextTick(function() {
				that.initmapTX();
			})
		},
		destroyed: function() {
			// map.remove(marker);
		},
		methods: {
			initmap: function() {
				console.log('加载地图');
				// 34.358723, 108.939319
				// var map = new AMap.Map('container', {
				// 	center: [108.939319,34.358723],
				// 	layers: [
				// 		// 卫星
				// 		new AMap.TileLayer.Satellite(),
				// 		// 路网
				// 		new AMap.TileLayer.RoadNet()
				// 	],
				// 	zoom: 13
				// });
				var position = new AMap.LngLat(108.939319, 34.358723);

				var map = new AMap.Map('container', {
					zoom: 15,
					center: position,
					resizeEnable: true
				});

				var marker2 = new AMap.Marker({
					position: position
				});

				map.add(marker2);

				var contentMarker = '<div class="marker-title">陕西领科新能源科技有限公司</div>';

				// 创建一个 Marker 实例：
				var marker = new AMap.Marker({
					position: position,
					// 将 html 传给 content
					content: contentMarker,
					// 以 icon 的 [center bottom] 为原点
					offset: new AMap.Pixel(10, -30),
					title: '陕西领科新能源科技有限公司'
				});

				// 将创建的点标记添加到已有的地图实例：
				map.add(marker);


			},
			initmapTX: function() {

				const that = this;
				// // 滚动事件 scroll
				// // 变形事件 resize
				// // window.addEventListener('resize', function() {
				// //   var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
				// //   if(scrolltop>0){
				// //     that.fun_change_style();
				// //   }
				// // }, false);
				TMap('NH4BZ-M5XK4-XUAUQ-FFFAC-IV5YQ-DWFL4').then(qq => {
					var map = new qq.maps.Map(document.getElementById("container"), {
						// 地图的中心地理坐标。
						center: new qq.maps.LatLng(34.358723, 108.939319),
						zoom: 17,
						pitch: 0, // 俯仰度
						rotation: 0, // 旋转角度
					});
					// 创建标记样式
					var markerIcon = new qq.maps.MarkerImage(
						require('@/assets/img/dw.png'),
						new qq.maps.Size(40, 40),
						new qq.maps.Point(0, 0),
						new qq.maps.Point(20, 40),
						new qq.maps.Size(40, 40));

					// 创建标记
					var marker = new qq.maps.Marker({
						position: new qq.maps.LatLng(34.358723, 108.939319),
						map: map,
						icon: markerIcon
					});

					// // 创建文本标记的样式
					var txtCss = {
						color: "#3777FF",
						fontSize: "16px",
						fontWeight: "bold"
					};
					// console.log(qq);
					// 创建文本标记对象
					var label = new qq.maps.Label({
						position: new qq.maps.LatLng(34.358723, 108.939319), // 标记的位置
						map: map, // 指定文本标记所在的地图
						// content: '我们在这里!'
					});

					label.setStyle(txtCss);
				})


			}



		}
	};
</script>
<style>
	/* 关于我们 */
	.aboutus {
		width: 1100px;
		margin: 0 auto;
	}

	.aboutus>h1 {
		text-align: center;
		color: #ed2112;
		font-size: 30px;
		margin-top: 80px;
		margin-bottom: 60px;
	}

	.aboutus>h2 {
		text-align: center;
		color: #ed2112;
		font-size: 20px;
		margin-top: 6px;
	}

	.aboutus .aboutus-one {
		overflow: hidden;
		padding: 96px 0 40px 0;
		border-bottom: 2px solid #999999;
		height: 400px;
	}

	.aboutus .aboutus-one>img {

		display: inline-block;
		margin-left: 70px;
	}

	.aboutus .aboutus-one>span {
		display: inline-block;
		width: 60%;
		text-align: left;
		font-size: 16px;
		line-height: 24px;
		/* letter-spacing: 1px; */
		margin-top: 10px;
	}

	.aboutus .aboutus-two>p {
		display: inline-block;
		text-align: center;
		margin: 30px 0px 0px 0px;
		color: #ed2112;
		font-size: 24px;
	}

	.aboutus .aboutus-two>ul {
		list-style-type: none;
		margin: 0 0 110px 0px;
	}

	.aboutus .aboutus-two>ul>li {
		text-align: center;
		font-size: 16px;
		margin-top: 28px;
		line-height: 24px;
		width: auto;
	}

	.marker-title {
		display: inline-block;
		color: #ed2112;
		width: 160px;
		font-size: 12px;
	}


	/* 关于我们结束 */
</style>